// extracted by mini-css-extract-plugin
export default {"label":"ShopperComment_label__4OFnF","value":"ShopperComment_value__zS8F6","error":"ShopperComment_error__lIP3k"};